import Vue from 'vue'
import { getInitials } from '@/src/plugins/helpers'

Vue.prototype.$getInitials = getInitials
